export default __webpack_public_path__ + "static/media/Custom-HUD-Altimeter (2 Layers).1380a7f7.jpg";